export default "__VITE_ASSET__BgyQy5oL__"